import { NgModule } from '@angular/core';
import { RouterModule, Routes, ActivatedRouteSnapshot } from '@angular/router';
import { CancelRefundComponent } from './components/cancel-refund/cancel-refund.component';
import { RefundStatusLookUpComponent } from './modules/refund-status/components/refund-status-look-up/refund-status-look-up.component';
import { RefundStatusInProgressComponent } from './modules/refund-status/components/refund-status-in-progress/refund-status-in-progress.component';
import { RefundStatusNotRefundedComponent } from './modules/refund-status/components/refund-status-not-refunded/refund-status-not-refunded.component';
import { RefundStatusRefundedComponent } from './modules/refund-status/components/refund-status-refunded/refund-status-refunded.component';
import { RefundStatusRouteGuardService } from './modules/refund-status/services/utils/refund-status-route-guard.service';
import { RefundStatusLookupRedirectComponent } from './modules/refund-status/components/refund-status-lookup-redirect/refund-status-lookup-redirect.component';

const routes: Routes = [
  { path: '', component: CancelRefundComponent },
  { path: 'cancelrefund', component: CancelRefundComponent },
  { path: 'refund/status/lookup', component: RefundStatusLookUpComponent },
  { path: 'refund/status/inprogress', component: RefundStatusInProgressComponent, canActivate: [RefundStatusRouteGuardService] },
  { path: 'refund/status/refunded', component: RefundStatusRefundedComponent, canActivate: [RefundStatusRouteGuardService] },
  { path: 'refund/status/notrefunded', component: RefundStatusNotRefundedComponent, canActivate: [RefundStatusRouteGuardService] },
  { path: 'cancelrefund/:refundEligibilityLiteRqJSON', component: CancelRefundComponent },
  { path: 'refund/status/lookupRedirect', component: RefundStatusLookupRedirectComponent },
  { path: '**', component: CancelRefundComponent }
];

@NgModule({
  declarations: [],
  // providers: [
  //   {
  //     provide: 'https://qasilo59-sjc.aa.com/reservations/cancelres/cancelFromRefund?recordLocator=',
  //     useValue: (route: ActivatedRouteSnapshot) => {
  //       const externalUrl = route.paramMap.get('externalUrl');
  //       window.open(externalUrl, '_self');
  //     },
  //   },
  // ],
  imports: [
    // RouterModule.forRoot(routes)
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
